// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriverRegistrationContainer {
  max-width: 1400px;
  margin: 0 auto;

  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
}

.DriverRegistrationHeader {
  text-align: center;
  /* margin-bottom: 32px; */
  /* padding: 24px; */
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  /* border-radius: 16px; */
  color: #000000;
  /* box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3); */
}

.DriverRegistrationTitle {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.DriverRegistrationIcon {
  font-size: 2.2rem;
}

.DriverRegistrationSubtitle {
  font-size: 1.1rem;
  margin: 0;
  opacity: 0.9;
  font-weight: 300;
}

/* Controls Section */
.DriverRegistrationControls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  gap: 16px;
  flex-wrap: wrap;
}

.DriverRegistrationSearchWrapper {
  flex: 1 1;
  max-width: 400px;
}

.DriverRegistrationSearchInput {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background-color: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.DriverRegistrationSearchInput:focus {
  outline: none;

  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.DriverRegistrationAddButton {
  /* background: linear-gradient(135deg, #10b981 0%, #059669 100%); */
  background: #06b6d4;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.DriverRegistrationAddButton:hover {
  transform: translateY(-2px);
}

.DriverRegistrationButtonIcon {
  display: flex;
  align-items: center;
}

/* Form Overlay */
.DriverRegistrationFormOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(4px);
}

.DriverRegistrationFormContainer {
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: DriverRegistrationSlideIn 0.3s ease-out;
}

@keyframes DriverRegistrationSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.DriverRegistrationFormHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 20px 20px 0 0;
}

.DriverRegistrationFormTitle {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.DriverRegistrationCloseButton {
  background: none;
  border: none;
  font-size: 2rem;
  color: #64748b;
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
  transition: all 0.2s ease;
  line-height: 1;
}

.DriverRegistrationCloseButton:hover {
  background-color: #f1f5f9;
  color: #ef4444;
}

/* Form Styles */
.DriverRegistrationForm {
  padding: 32px;
}

.DriverRegistrationFormGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 32px;
}

.DriverRegistrationFormGroup {
  display: flex;
  flex-direction: column;
}

.DriverRegistrationLabel {
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  font-size: 0.95rem;
}

.DriverRegistrationInput {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background-color: #fafafa;
}

.DriverRegistrationInput:focus {
  outline: none;
  border-color: #667eea;
  background-color: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.DriverRegistrationFormActions {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

.DriverRegistrationSaveButton {
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.DriverRegistrationSaveButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.DriverRegistrationCancelButton {
  background: #f8fafc;
  color: #64748b;
  border: 2px solid #e2e8f0;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.DriverRegistrationCancelButton:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

/* Table Container */
.DriverRegistrationTableContainer {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.DriverRegistrationTableHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  background: #06b6d4;
  border-bottom: 1px solid #e2e8f0;
}

.DriverRegistrationTableTitle {
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.DriverRegistrationStats {
  display: flex;
  gap: 16px;
}

.DriverRegistrationStatsItem {
  background: #667eea;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.DriverRegistrationTableWrapper {
  overflow-x: auto;
}

.DriverRegistrationTable {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.DriverRegistrationTableHead {
  background: #f8fafc;
}

.DriverRegistrationTableRow {
  display: table-row;
}

.DriverRegistrationTableRow:nth-child(even) {
  background-color: #f9fafb;
}

.DriverRegistrationTableHeader {
  display: table-cell;
  padding: 16px 20px;
  text-align: left;
  font-weight: 700;
  color: #ffffff;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e5e7eb;
  vertical-align: middle;
  writing-mode: horizontal-tb;
}

.DriverRegistrationTableCell {
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
  display: table-cell;
}

.DriverRegistrationTableCellIndex {
  font-weight: 600;
  color: #6b7280;
  width: 60px;
}

.DriverRegistrationTableCellName {
  font-weight: 600;
  color: #1f2937;
}

.DriverRegistrationTableCellActions {
  width: 100px;
  display: flex;
  gap: 8px;
}

.DriverRegistrationStatusBadge {
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.DriverRegistrationStatusButton {
  background: none;
  border: none;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.DriverRegistrationStatusButton:hover {
  background-color: #fee2e2;
  transform: scale(1.1);
}

.DriverRegistrationStatusButton svg {
  color: #ef4444;
  stroke-width: 2;
}

.DriverRegistrationTableCellEmpty {
  text-align: center;
  padding: 48px 20px;
}

.DriverRegistrationEmptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #6b7280;
}

.DriverRegistrationEmptyIcon {
  font-size: 3rem;
  opacity: 0.5;
}

.DriverRegistrationEmptyState p {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.DriverRegistrationEmptySubtext {
  font-size: 0.9rem !important;
  font-weight: 400 !important;
  opacity: 0.7;
}

/* Responsive Design */
@media (max-width: 768px) {
  .DriverRegistrationContainer {
    padding: 16px;
  }

  .DriverRegistrationTitle {
    font-size: 2rem;
  }

  .DriverRegistrationControls {
    flex-direction: column;
    align-items: stretch;
  }

  .DriverRegistrationSearchWrapper {
    max-width: none;
  }

  .DriverRegistrationFormGrid {
    grid-template-columns: 1fr;
  }

  .DriverRegistrationForm {
    padding: 24px;
  }

  .DriverRegistrationFormActions {
    flex-direction: column;
  }

  .DriverRegistrationTableHeader {
    padding: 16px 20px;
  }

  .DriverRegistrationTable {
    min-width: 600px;
  }

  .DriverRegistrationTableWrapper {
    overflow-x: auto;
  }

  .DriverRegistrationTableCell {
    padding: 12px 16px;
  }
}

@media (max-width: 480px) {
  .DriverRegistrationTitle {
    font-size: 1.8rem;
    flex-direction: column;
    gap: 8px;
  }

  .DriverRegistrationFormOverlay {
    padding: 10px;
  }

  .DriverRegistrationFormContainer {
    border-radius: 16px;
  }

  .DriverRegistrationFormHeader {
    padding: 20px 24px;
    border-radius: 16px 16px 0 0;
  }

  .DriverRegistrationForm {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Registration/DriverRegistration.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;;EAEd;iCAC+B;EAC/B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mEAAmE;EACnE,yBAAyB;EACzB,cAAc;EACd,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;;EAEb,8CAA8C;AAChD;;AAEA;EACE,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".DriverRegistrationContainer {\n  max-width: 1400px;\n  margin: 0 auto;\n\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, sans-serif;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n.DriverRegistrationHeader {\n  text-align: center;\n  /* margin-bottom: 32px; */\n  /* padding: 24px; */\n  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */\n  /* border-radius: 16px; */\n  color: #000000;\n  /* box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3); */\n}\n\n.DriverRegistrationTitle {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.DriverRegistrationIcon {\n  font-size: 2.2rem;\n}\n\n.DriverRegistrationSubtitle {\n  font-size: 1.1rem;\n  margin: 0;\n  opacity: 0.9;\n  font-weight: 300;\n}\n\n/* Controls Section */\n.DriverRegistrationControls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.DriverRegistrationSearchWrapper {\n  flex: 1;\n  max-width: 400px;\n}\n\n.DriverRegistrationSearchInput {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background-color: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.DriverRegistrationSearchInput:focus {\n  outline: none;\n\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.DriverRegistrationAddButton {\n  /* background: linear-gradient(135deg, #10b981 0%, #059669 100%); */\n  background: #06b6d4;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n}\n\n.DriverRegistrationAddButton:hover {\n  transform: translateY(-2px);\n}\n\n.DriverRegistrationButtonIcon {\n  display: flex;\n  align-items: center;\n}\n\n/* Form Overlay */\n.DriverRegistrationFormOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(4px);\n}\n\n.DriverRegistrationFormContainer {\n  background: white;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: DriverRegistrationSlideIn 0.3s ease-out;\n}\n\n@keyframes DriverRegistrationSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.DriverRegistrationFormHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px;\n  border-bottom: 1px solid #e2e8f0;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 20px 20px 0 0;\n}\n\n.DriverRegistrationFormTitle {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n.DriverRegistrationCloseButton {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: #64748b;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  line-height: 1;\n}\n\n.DriverRegistrationCloseButton:hover {\n  background-color: #f1f5f9;\n  color: #ef4444;\n}\n\n/* Form Styles */\n.DriverRegistrationForm {\n  padding: 32px;\n}\n\n.DriverRegistrationFormGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.DriverRegistrationFormGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n.DriverRegistrationLabel {\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n  font-size: 0.95rem;\n}\n\n.DriverRegistrationInput {\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background-color: #fafafa;\n}\n\n.DriverRegistrationInput:focus {\n  outline: none;\n  border-color: #667eea;\n  background-color: white;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.DriverRegistrationFormActions {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding-top: 24px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.DriverRegistrationSaveButton {\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.DriverRegistrationSaveButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.DriverRegistrationCancelButton {\n  background: #f8fafc;\n  color: #64748b;\n  border: 2px solid #e2e8f0;\n  padding: 12px 24px;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.DriverRegistrationCancelButton:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n/* Table Container */\n.DriverRegistrationTableContainer {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.DriverRegistrationTableHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px;\n  background: #06b6d4;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.DriverRegistrationTableTitle {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n.DriverRegistrationStats {\n  display: flex;\n  gap: 16px;\n}\n\n.DriverRegistrationStatsItem {\n  background: #667eea;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.DriverRegistrationTableWrapper {\n  overflow-x: auto;\n}\n\n.DriverRegistrationTable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.DriverRegistrationTableHead {\n  background: #f8fafc;\n}\n\n.DriverRegistrationTableRow {\n  display: table-row;\n}\n\n.DriverRegistrationTableRow:nth-child(even) {\n  background-color: #f9fafb;\n}\n\n.DriverRegistrationTableHeader {\n  display: table-cell;\n  padding: 16px 20px;\n  text-align: left;\n  font-weight: 700;\n  color: #ffffff;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #e5e7eb;\n  vertical-align: middle;\n  writing-mode: horizontal-tb;\n}\n\n.DriverRegistrationTableCell {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f3f4f6;\n  vertical-align: middle;\n  display: table-cell;\n}\n\n.DriverRegistrationTableCellIndex {\n  font-weight: 600;\n  color: #6b7280;\n  width: 60px;\n}\n\n.DriverRegistrationTableCellName {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.DriverRegistrationTableCellActions {\n  width: 100px;\n  display: flex;\n  gap: 8px;\n}\n\n.DriverRegistrationStatusBadge {\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.DriverRegistrationStatusButton {\n  background: none;\n  border: none;\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.DriverRegistrationStatusButton:hover {\n  background-color: #fee2e2;\n  transform: scale(1.1);\n}\n\n.DriverRegistrationStatusButton svg {\n  color: #ef4444;\n  stroke-width: 2;\n}\n\n.DriverRegistrationTableCellEmpty {\n  text-align: center;\n  padding: 48px 20px;\n}\n\n.DriverRegistrationEmptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: #6b7280;\n}\n\n.DriverRegistrationEmptyIcon {\n  font-size: 3rem;\n  opacity: 0.5;\n}\n\n.DriverRegistrationEmptyState p {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.DriverRegistrationEmptySubtext {\n  font-size: 0.9rem !important;\n  font-weight: 400 !important;\n  opacity: 0.7;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .DriverRegistrationContainer {\n    padding: 16px;\n  }\n\n  .DriverRegistrationTitle {\n    font-size: 2rem;\n  }\n\n  .DriverRegistrationControls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .DriverRegistrationSearchWrapper {\n    max-width: none;\n  }\n\n  .DriverRegistrationFormGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .DriverRegistrationForm {\n    padding: 24px;\n  }\n\n  .DriverRegistrationFormActions {\n    flex-direction: column;\n  }\n\n  .DriverRegistrationTableHeader {\n    padding: 16px 20px;\n  }\n\n  .DriverRegistrationTable {\n    min-width: 600px;\n  }\n\n  .DriverRegistrationTableWrapper {\n    overflow-x: auto;\n  }\n\n  .DriverRegistrationTableCell {\n    padding: 12px 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .DriverRegistrationTitle {\n    font-size: 1.8rem;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .DriverRegistrationFormOverlay {\n    padding: 10px;\n  }\n\n  .DriverRegistrationFormContainer {\n    border-radius: 16px;\n  }\n\n  .DriverRegistrationFormHeader {\n    padding: 20px 24px;\n    border-radius: 16px 16px 0 0;\n  }\n\n  .DriverRegistrationForm {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
